// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Fbmy","consentsList":"PatientConsents_consentsList__20cBL","consentsListEmpty":"PatientConsents_consentsListEmpty__2rkXZ"};